export function buildGetFeatureInfoUrl(map, layer, latlng, infoFormat = "text/plain") {
    const point = map.latLngToContainerPoint(latlng, map.getZoom());
    const size = map.getSize();

    const params = {
        request: 'GetFeatureInfo',
        service: 'WMS',
        srs: 'EPSG:4326',
        styles: '',
        transparent: true,
        version: '1.1.1',
        format: 'image/png',
        bbox: map.getBounds().toBBoxString(),
        height: size.y,
        width: size.x,
        layers: layer.options.layers,
        query_layers: layer.options.layers,
        info_format: infoFormat,
        feature_count: 100,
        x: Math.floor(point.x),
        y: Math.floor(point.y),
    };

    const baseUrl = layer._url;
    const joinChar = baseUrl.includes('?') ? '&' : '?';
    const queryString = Object.entries(params)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');

    return `${baseUrl}${joinChar}${queryString}`;
}

export function getProperWmsUrl(layerName) {
  const layersViaMapserver = ['Articulação Sistemática', 'Bases de Voo', 'Aeroporto', 'RBMC'];
  const MAPCACHE_URL = "https://paranamap.esteio.com.br/mapcache/"; 

  if (layersViaMapserver.includes(layerName)) {
    return "https://paranamap.esteio.com.br/mapserver?map=/ms4w/apps/sgp/sgp.map";
  }
  return MAPCACHE_URL;
}

